module.exports = __webpack_public_path__ + "media/styles/images/svg/check-teal-b9107d4a8d0d794d7dde6b8cf0dd45a6.svg";